import {
  FooterMinimalCopyright,
  FooterMinimalLinksContainer,
  FooterMinimalWrapper,
} from './FooterMinimal.style';
import Link from 'next/link';
import { StoryblokComponent } from '@storyblok/react';
import { FooterminimalComponent } from '../../api';
import { FooterMinimalLinkStoryblok } from './FooterMinimal.types';
import { patchedStoryblokEditable } from '../../utils/patchedStoryblokEditable';

export const FooterMinimal = (props: FooterminimalComponent) => {
  const { links = [] } = props;

  return (
    <FooterMinimalWrapper {...patchedStoryblokEditable(props)}>
      <FooterMinimalCopyright>
        URBAN © {new Date().getFullYear()}. All rights reserved
      </FooterMinimalCopyright>
      <FooterMinimalLinksContainer>
        {links
          .filter((linkBlok: FooterMinimalLinkStoryblok) => !!linkBlok.title.length)
          .map((linkBlok: FooterMinimalLinkStoryblok) => (
            <Link href={linkBlok.link.cached_url || linkBlok.link.url} key={linkBlok._uid} passHref>
              <a {...patchedStoryblokEditable(linkBlok)}>
                <StoryblokComponent blok={linkBlok.title[0]} />
              </a>
            </Link>
          ))}
      </FooterMinimalLinksContainer>
    </FooterMinimalWrapper>
  );
};
